// app/utils/pathUtils.ts

/**
 * Normalize a URL or path:
 * - extract pathname
 * - remove trailing slash (except for root "/")
 * - ignore query string
 * Returns null if invalid
 */
export function normalizePath(path?: string | null): string | null {
  if (!path || typeof path !== "string") return null;

  try {
    const u = new URL(path, "http://dummy"); // safe for relative paths
    let clean = u.pathname;
    if (clean.endsWith("/") && clean.length > 1) clean = clean.slice(0, -1);
    return clean;
  } catch {
    return null;
  }
}

/**
 * Check if a path string is valid (can be normalized)
 */
export function isValidPath(path?: string | null): boolean {
  return normalizePath(path) !== null;
}

/**
 * Check if the given full URL or path is in the provided list of endpoints
 */
export function isEndpointInList(fullUrl: string, endpoints: string[]): boolean {
  const currentPath = normalizePath(fullUrl);
  if (!currentPath) return false;

  return endpoints.some((p) => normalizePath(p) === currentPath);
}


